/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */
var secondsToMilliseconds = function secondsToMilliseconds(seconds) {
  return seconds * 1000;
};
var millisecondsToSeconds = function millisecondsToSeconds(milliseconds) {
  return milliseconds / 1000;
};
export { millisecondsToSeconds, secondsToMilliseconds };